import { CarrierVisitStatus, VesselType } from '@planning/app/api'
import { ContainerJourneyStatus } from '@planning/components/molecules/ContainerJourneyStatusChip'
import { tomTableColumnFilterPresets } from '@tom-ui/ui'
import { MRT_ColumnDef, MRT_RowData } from 'material-react-table'

export const columnFilterPresets = {
  ...tomTableColumnFilterPresets,
  importTransshipmentOverlanded: <T extends MRT_RowData>(): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: ['Import', 'Transshipment', 'Overlanded'],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  exportTransshipmentOverlanded: <T extends MRT_RowData>(): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: ['Export', 'Transshipment', 'Overlanded'],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  fullEmptySelect: <T extends MRT_RowData>(): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: ['Full', 'Empty'],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
  orderStatusMultiSelect: <T extends MRT_RowData>(): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'multi-select',
    filterSelectOptions: Object.values(ContainerJourneyStatus).map(status => ({
      label: (() => {
        switch (status) {
          case ContainerJourneyStatus.OnTerminal:
            return 'On Terminal'
          case ContainerJourneyStatus.OnYard:
            return 'On Yard'
          default:
            return status
        }
      })(),
      value: status,
    })),
    filterFn: (row, columnId, filterValue) => {
      if (filterValue?.length <= 0) return true

      const value = row.getValue<string>(columnId)
      const filters = [...filterValue]

      if (filterValue?.includes('Expected')) {
        filters.push('-')
      }

      return filters.includes(value)
    },
    enableColumnFilterModes: false,
  }),
  vesselVisitStatusMultiSelect: <T extends MRT_RowData>(): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'multi-select',
    filterSelectOptions: Object.values(CarrierVisitStatus).map(status => ({
      label: (() => {
        switch (status) {
          case CarrierVisitStatus.InOperation:
            return 'In Operation'
          default:
            return status
        }
      })(),
      value: status,
    })),
    filterFn: (row, columnId, filterValue) => {
      if (filterValue?.length <= 0) return true

      const value = row.getValue<string>(columnId)
      const filters = [...filterValue]

      if (filterValue?.includes('Expected')) {
        filters.push('-')
      }

      return filters.includes(value)
    },
    enableColumnFilterModes: false,
  }),
  vesselTypeMultiSelect: <T extends MRT_RowData>(): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'multi-select',
    filterSelectOptions: Object.values(VesselType).map(type => ({
      label: (() => {
        switch (type) {
          case VesselType.BargeCarrier:
            return 'Barge carrier'
          case VesselType.ContainerRoRo:
            return 'Container RoRo'
          case VesselType.GeneralCargo:
            return 'General cargo'
          case VesselType.SemiContainer:
            return 'Semi container'
          default:
            return type
        }
      })(),
      value: type,
    })),
    filterFn: (row, columnId, filterValue) => {
      if (!filterValue || (filterValue as string[]).length === 0) return true
      const value = row.getValue<string>(columnId)
      return (filterValue as string[]).includes(value)
    },
    enableColumnFilterModes: false,
  }),
  openFulfilledSelect: <T extends MRT_RowData>(): Partial<MRT_ColumnDef<T, unknown>> => ({
    filterVariant: 'select',
    filterSelectOptions: ['Open', 'Fulfilled'],
    filterFn: 'equals',
    enableColumnFilterModes: false,
  }),
}
